export default "__VITE_PUBLIC_ASSET__32802ec7__"